import { Component } from '@angular/core';

@Component({
  selector: 'app-permissions-layout',
  templateUrl: './permissions-layout.component.html',
})
export class PermissionsLayoutComponent {}
